import type { ActivePerson } from '@indusketch/shared';
import { useI18n } from '../../i18n/i18n.js';

/** People in the project right now: pulsing dot with their names. */
export function ActiveBadge({
  users,
  variant = 'inline',
}: {
  users: readonly ActivePerson[];
  /** `overlay` sits on a preview image, `compact` shows only the names. */
  variant?: 'inline' | 'overlay' | 'compact';
}) {
  const { m, fmt } = useI18n();
  if (users.length === 0) return null;
  const names = users.map((u) => u.displayName).join(', ');
  const text = fmt(m.projects.activeNow, { names });
  return (
    <span className={`live-badge is-${variant}`} title={text} data-testid="active-badge">
      <span className="live-dot" aria-hidden />
      <span className="live-badge-text">{variant === 'compact' ? names : text}</span>
    </span>
  );
}

/** Everybody active in any of the given projects, each person once. */
export function activeIn(
  projects: readonly { activeUsers?: readonly ActivePerson[] | undefined }[],
): ActivePerson[] {
  const out: ActivePerson[] = [];
  for (const p of projects)
    for (const u of p.activeUsers ?? []) if (!out.some((x) => x.id === u.id)) out.push(u);
  return out;
}
